import { z } from 'zod';
import { AUDIT_CATEGORY_VALUES } from '@fas/types';
import { isoDateSchema, paginationQuerySchema, uuidSchema } from './common';

export const listAuditLogsQuerySchema = paginationQuerySchema.extend({
  category: z.enum(AUDIT_CATEGORY_VALUES).optional(),
  action: z.string().trim().max(100).optional(),
  entityType: z.string().trim().max(60).optional(),
  entityId: z.string().trim().max(64).optional(),
  actorUserId: uuidSchema.optional(),
  correlationId: z.string().trim().max(100).optional(),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
});
export type ListAuditLogsQuery = z.infer<typeof listAuditLogsQuerySchema>;

export const updateSettingSchema = z.object({
  value: z.unknown(),
});
export type UpdateSettingInput = z.infer<typeof updateSettingSchema>;
